import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found.component';

const routes: Routes = [
  { path: 'not-found', component: PageNotFoundComponent },
  { path: 'samples', loadChildren: 'app/public/samples/samples.module#SamplesModule' },
  { path: 'mocks', loadChildren: 'app/public/mocks/mocks.module#MocksModule' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/public/public-routing.module.ts